var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"send-value-commerce-data"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("バリューコマース 自動連携依頼")])])],1),_c('el-row',[_c('el-col',[_c('ValueCommerceDataRegister')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }